import DOMPurify from "dompurify";

/*
 * Central HTML sanitiser for stored rich-text (TinyMCE / legacy CKEditor /
 * Summernote output).
 *
 * This content crosses users (data-entry operator -> admin, client -> advisor),
 * so every place it is rendered with dangerouslySetInnerHTML is a stored-XSS
 * sink. Sanitising on the way OUT (render), not just on save, is what actually
 * protects viewers - it also neutralises any malicious HTML already sitting in
 * the database from before this fix.
 *
 * DOMPurify's defaults preserve the formatting our editors produce (bold,
 * lists, tables, links, colours and base64 <img>) while stripping <script>,
 * inline event handlers (onerror/onclick/...) and javascript: URLs.
 */

let hooksInstalled = false;
const installHooks = () => {
  if (hooksInstalled) return;
  // Any link that opens a new tab gets rel="noopener noreferrer".
  DOMPurify.addHook("afterSanitizeAttributes", (node: any) => {
    if (
      node &&
      typeof node.getAttribute === "function" &&
      node.tagName === "A" &&
      node.getAttribute("target") === "_blank"
    ) {
      node.setAttribute("rel", "noopener noreferrer");
    }
  });
  hooksInstalled = true;
};

/** Sanitise a rich-text HTML string for safe rendering. */
export const sanitizeHtml = (dirty: any): string => {
  installHooks();
  if (dirty === null || dirty === undefined) return "";
  return DOMPurify.sanitize(String(dirty));
};

/** Convenience for `dangerouslySetInnerHTML={htmlProps(value)}`. */
export const htmlProps = (dirty: any): { __html: string } => ({
  __html: sanitizeHtml(dirty),
});
